var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card-text", { staticStyle: { "min-height": "396px" } }, [
        _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "subheading font-weight-medium baseline" },
              [
                _vm._v("\n        Include Gaps Data\n        "),
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "offset-y": "",
                      "open-on-hover": "",
                      "open-delay": 400,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-icon",
                              _vm._g(
                                {
                                  staticClass: "clickable ml-2",
                                  attrs: { color: "primary" },
                                },
                                on
                              ),
                              [
                                _vm._v(
                                  "\n              info_outline\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "v-card",
                      [
                        _c("v-card-text", [
                          _c("div", { staticClass: "mb-2" }, [
                            _c("strong", [_vm._v("Yes")]),
                            _vm._v(
                              " Gaps data would be included in the report.\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-2" }, [
                            _c("strong", [_vm._v("No")]),
                            _vm._v(
                              " Gaps data would be excluded from the report.\n              "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-radio-group",
              {
                staticClass: "mt-1 mb-4",
                attrs: { disabled: _vm.disabled, "hide-details": "" },
                model: {
                  value: _vm.reportOptions.includeGaps,
                  callback: function ($$v) {
                    _vm.$set(_vm.reportOptions, "includeGaps", $$v)
                  },
                  expression: "reportOptions.includeGaps",
                },
              },
              [
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-radio", {
                          attrs: {
                            color: "primary",
                            label: "Yes",
                            value: true,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      [
                        _c("v-radio", {
                          attrs: {
                            color: "primary",
                            label: "No",
                            value: false,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }